export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/ai-smart-contract-auditing-2026": [~3],
		"/blog-posts/coinbase-dex-expansion-testmachine-token-safety": [~6],
		"/blog-posts/smart-contract-audit-tools-2026": [~7],
		"/blog-posts/testmachine-raises-6-5m-ai-blockchain-security": [~8],
		"/blog": [4],
		"/blog/[slug]": [5],
		"/contact": [9],
		"/exchanges": [~10],
		"/products/azimuth": [11],
		"/products/token-custody": [12],
		"/solutions": [13]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';